import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ColorModeProvider } from './contexts/ColorModeContext';
import { DisplaySizeProvider, useDisplaySize } from './contexts/DisplaySizeContext';
import Layout from './components/layout/Layout';
import { config } from './config/config';
import { routes, RouteConfig } from './config/routes';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Login } from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import NotFound from './pages/NotFound';

const renderRoutes = (routeConfig: RouteConfig[]) => {
  return routeConfig.map((route) => {
    if (route.children) {
      return (
        <Route key={route.id} path={route.path} element={route.element}>
          {renderRoutes(route.children)}
        </Route>
      );
    }
    return <Route key={route.id} path={route.path} element={route.element} />;
  });
};

const AppContent: React.FC = () => {
  const { size } = useDisplaySize();
  
  return (
    <ColorModeProvider displaySize={size}>
      <GoogleOAuthProvider clientId={config.auth.google.clientId}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dp-portal" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dp-entry" element={<Navigate to="/setup/collection-points" replace />} />
            {renderRoutes(routes)}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </GoogleOAuthProvider>
    </ColorModeProvider>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DisplaySizeProvider>
          <AppContent />
        </DisplaySizeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
